/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type EnumsOrderState = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export const EnumsOrderState = {
    Nueva: 0 as EnumsOrderState,
    Aceptada: 1 as EnumsOrderState,
    Rechazada: 2 as EnumsOrderState,
    AsignadaCadete: 3 as EnumsOrderState,
    Cancelada: 4 as EnumsOrderState,
    CadeteConfirmado: 5 as EnumsOrderState,
    EnViaje: 6 as EnumsOrderState,
    Finalizada: 7 as EnumsOrderState,
    Devuelta: 8 as EnumsOrderState
};